import { toast } from "@/components/ui";
import { useEffect, useMemo } from "react";
import { sortPinnedMessages } from "./Messages.util";
import { MessagesTable } from "./MessagesTable";
import { useAsyncMessageInbox } from "./network/useAsyncMessageInbox";
import { usePinnedPatients } from "./network/usePinnedPatients";

export const MessagesInbox = () => {
  const { data: inboxData, isError, isLoading } = useAsyncMessageInbox();
  const { data: pinnedPatientsData, isError: isPinnedPatientsError } =
    usePinnedPatients();

  const messages = useMemo(() => {
    return sortPinnedMessages(
      inboxData?.asyncMessages,
      pinnedPatientsData?.patientIds,
    );
  }, [inboxData, pinnedPatientsData]);

  useEffect(() => {
    if (isPinnedPatientsError)
      toast.error("Failed to fetch pinned patients", {
        id: "async-dashboard-pinned-patients",
      });
  }, [isPinnedPatientsError]);

  return (
    <MessagesTable
      messages={messages}
      archived={false}
      isLoading={isLoading}
      isError={isError}
    />
  );
};
